import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import RssFeedIcon from '@mui/icons-material/RssFeed';
import RssFeedRoundedIcon from '@mui/icons-material/RssFeedRounded';
import discoverStore from './DiscoverNew/store';
import logo from '../sidebar-logo.png';
import mixpanel from 'mixpanel-browser';
import './FeedsDirectory.scss';
import { setLandingPage } from '../utils/trackingParams';
import Loader from '../Components/Loader';
import { observer } from 'mobx-react';

const FeedsDirectory = () => {
  console.log('FeedsDirectory render - allFeedsLoading:', discoverStore.allFeedsLoading, 'allFeeds length:', discoverStore.allFeeds.length);
  const [loadTimeout, setLoadTimeout] = useState(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const currentParams = searchParams.toString();

  useEffect(() => {
    // Track page visit with consistent event name
    mixpanel.track('Landing Page Visited', {
      page: 'feeds_directory',
      utm_landingpage: 'feeds_directory'
    });
    setLandingPage('feeds_directory');
    mixpanel.start_session_recording();

    discoverStore.fetchAllFeeds();
    const timeout = setTimeout(() => setLoadTimeout(true), 10000);
    return () => clearTimeout(timeout);
  }, [location]);

  if (discoverStore.allFeedsLoading) {
    return (
      <div className="feeds-directory">
        {/* Mobile Header */}
        <div className="mobile-header">
          <Link to="/" style={{ textDecoration: 'none' }}>
            <img src={logo} className="audiblogs-logo" alt="logo" />
          </Link>
          <Link 
            className="mobile-cta-button" 
            to={`/signin?source=feeds_directory&utm_source=feeds_directory${currentParams ? `&${currentParams}` : ''}`}
          >
            Start Listening
          </Link>
        </div>

        <div className="nav-bar">
          <div style={{ display: 'flex', alignItems: 'flex-start' }}>
            <Link to="/" style={{ textDecoration: 'none' }}>
              <img src={logo} className="audiblogs-logo" alt="logo" />
            </Link>
            <div style={{ marginLeft: '50px' }} className="ph-badge">
              <a
                href="https://www.producthunt.com/posts/audiblogs?utm_source=badge-top-post-badge&utm_medium=badge&utm_souce=badge-audiblogs"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://api.producthunt.com/widgets/embed-image/v1/top-post-badge.svg?post_id=283759&theme=dark&period=monthly"
                  alt="Audioread - Listen to any web article in your podcast player | Product Hunt"
                  style={{ width: '250px', height: '54px' }}
                  width="250"
                  height="54"
                />
              </a>
            </div>
          </div>
          <div className="desktop-nav">
            <div style={{ marginTop: '10px', display: 'flex', alignItems: 'center', gap: '20px', fontSize: '1.05rem', fontWeight: 'bold' }}>
              <Link
                className="signin-button"
                to="/freeaitexttospeech"
              >
                Free Converter
              </Link>
              <Link
                className="signin-button"
                to={{ pathname: "https://help.audioread.com/en/collections/12375780-use-cases" }}
                target="_blank"
              >
                Use Cases
              </Link>
              <Link 
                className="signin-button" 
                to={`/signin?source=feeds_nav_signin${currentParams ? `&${currentParams}` : ''}`}
              >
                Sign In
              </Link>
              <div style={{display: 'flex', alignItems: 'center', transform: 'scale(0.75)', marginLeft: '-20px'}}>
                <div className="cta-div" style={{ position: 'static', width: 'auto', paddingBottom: '18px' }}>
                  <Link 
                    className="cta-button" 
                    to={`/signin?source=feeds_nav_cta${currentParams ? `&${currentParams}` : ''}`} 
                    style={{ marginTop: '0px' }}
                  >
                    Start listening
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="feeds-content">
          <div className="page-title">
            <RssFeedRoundedIcon sx={{ 
              fontSize: '3rem',
              background: 'linear-gradient(135deg, #4292fa 0%, #e82186 100%)',
              borderRadius: '50%',
              padding: '10px',
              marginRight: '15px',
              boxShadow: '0 4px 20px rgba(15, 15, 25, 0.98)'
            }} />
            <h1>Feeds</h1>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', padding: '50px 0' }}>
            <Loader fullScreen={false} backgroundColor="#000" size={80} />
          </div>
        </div>
      </div>
    );
  }

  if (loadTimeout && discoverStore.allFeedsLoading && discoverStore.allFeeds.length === 0) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#000',
        color: '#fff',
      }}>
        <div style={{ fontSize: 22, marginBottom: 16 }}>Feeds still loading...</div>
        <button
          style={{
            padding: '10px 24px',
            background: 'rgb(255 143 65)',
            color: '#fff',
            border: 'none',
            borderRadius: 6,
            fontSize: 16,
            cursor: 'pointer',
          }}
          onClick={() => {
            setLoadTimeout(false);
            discoverStore.fetchAllFeeds();
          }}
        >
          Please wait...
        </button>
      </div>
    );
  }

  return (
    <div className="feeds-directory">
      {/* Mobile Header */}
      <div className="mobile-header">
        <Link to="/" style={{ textDecoration: 'none' }}>
          <img src={logo} className="audiblogs-logo" alt="logo" />
        </Link>
        <Link 
          className="mobile-cta-button" 
          to={`/signin?source=feeds_directory&utm_source=feeds_directory${currentParams ? `&${currentParams}` : ''}`}
        >
          Start Listening
        </Link>
      </div>

      <div className="nav-bar">
        <div style={{ display: 'flex', alignItems: 'flex-start' }}>
          <Link to="/" style={{ textDecoration: 'none' }}>
            <img src={logo} className="audiblogs-logo" alt="logo" />
          </Link>
          <div style={{ marginLeft: '50px' }} className="ph-badge">
            <a
              href="https://www.producthunt.com/posts/audiblogs?utm_source=badge-top-post-badge&utm_medium=badge&utm_souce=badge-audiblogs"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://api.producthunt.com/widgets/embed-image/v1/top-post-badge.svg?post_id=283759&theme=dark&period=monthly"
                alt="Audioread - Listen to any web article in your podcast player | Product Hunt"
                style={{ width: '250px', height: '54px' }}
                width="250"
                height="54"
              />
            </a>
          </div>
        </div>
        <div className="desktop-nav">
          <div style={{ marginTop: '10px', display: 'flex', alignItems: 'center', gap: '20px', fontSize: '1.05rem', fontWeight: 'bold' }}>
            <Link
              className="signin-button"
              to="/freeaitexttospeech"
            >
              Free Converter
            </Link>
            <Link
              className="signin-button"
              to={{ pathname: "https://help.audioread.com/en/collections/12375780-use-cases" }}
              target="_blank"
            >
              Use Cases
            </Link>
            <Link 
              className="signin-button" 
              to={`/signin?source=feeds_nav_signin${currentParams ? `&${currentParams}` : ''}`}
            >
              Sign In
            </Link>
            <div style={{display: 'flex', alignItems: 'center', transform: 'scale(0.75)', marginLeft: '-20px'}}>
              <div className="cta-div" style={{ position: 'static', width: 'auto' }}>
                <Link 
                  className="cta-button" 
                  to={`/signin?source=feeds_nav_cta${currentParams ? `&${currentParams}` : ''}`} 
                  style={{ marginTop: '0px' }}
                >
                  Start listening
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="feeds-content">
        <div className="page-title">
          <RssFeedRoundedIcon sx={{ 
            fontSize: '3rem',
            background: 'linear-gradient(135deg, #4292fa 0%, #e82186 100%)',
            borderRadius: '50%',
            padding: '10px',
            marginRight: '15px',
            boxShadow: '0 4px 20px rgba(15, 15, 25, 0.98)'
          }} />
          <h1>Feeds</h1>
        </div>
        <div className="feeds-grid">
          {discoverStore.allFeeds.map((feed) => (
            <Link
              key={feed.feed_id}
              to={`/feed/${feed.feed_id}`}
              className="feed-card"
            >
              <div className="feed-thumbnail">
                {feed.thumbnail_url ? (
                  <img src={feed.thumbnail_url} alt={feed.title} />
                ) : (
                  <RssFeedRoundedIcon className="feed-icon" />
                )}
              </div>
              <div className="feed-info">
                <h3>{feed.title}</h3>
                {feed.description && <p>{feed.description}</p>}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default observer(FeedsDirectory); 